import { createContext } from "react";
import { PopupManagement } from '../../models/cookies/popupManagement'

// Valor por defecto
const defaultValue = new PopupManagement();

// Creación de Context para su posterior configuración propia del cliente para la aplicación
export const CookiePopUp = createContext(defaultValue);